module.exports = __webpack_public_path__ + "static/upscale-24fc2d4efa978c858e906f48475b6228.webp";